<div class="header">
  <div class="center">
    <div class="popup-message">
      <h2>{{ 'OPEN_LINK.TITLE' | translate }}</h2>
    </div>
  </div>
</div>
<div class="content">
  <div class="popup-message">
    <h3>
      <p>
        {{ 'OPEN_LINK.FIRST_SUBTITLE' | translate }}
      </p>
    </h3>
    <h3>
      <p>
        {{ 'OPEN_LINK.SECOND_SUBTITLE' | translate }}
      </p>
    </h3>
  </div>
</div>

<div class="popup-footer">
  <ion-button
    expand="full"
    strong="true"
    fill="clear"
    color="dark"
    (click)="validated.emit('cancel')"
  >
    {{ 'CANCEL' | translate }}
  </ion-button>

  <ion-button
    expand="full"
    strong="true"
    fill="clear"
    [color]="color"
    (click)="validated.emit('continue')"
  >
    {{ 'OK' | translate }}
  </ion-button>
</div>
